/** Directory ranking: United States first, then other listed countries, then everywhere else. */

const US = /\bunited states\b|\busa\b|\bu\.s\.a?\b|(^|\s)us(\s|$)/;
const CA = /\bcanada\b/;
const UK = /\bunited kingdom\b|\buk\b|\bengland\b|\bscotland\b|\bwales\b/;
const FR = /\bfrance\b/;
const DE = /\bgermany\b|\bdeutschland\b/;
const JP = /\bjapan\b/;
const SG = /\bsingapore\b/;
const CN = /\bchina\b|\bprc\b/;
const IN = /\bindia\b/;

const REGION_MATCHERS = {
  USA: (text) => US.test(text) || text === 'us',
  Canada: (text) => CA.test(text),
  UK: (text) => UK.test(text),
  France: (text) => FR.test(text),
  Germany: (text) => DE.test(text),
  Japan: (text) => JP.test(text),
  Singapore: (text) => SG.test(text),
  China: (text) => CN.test(text),
  India: (text) => IN.test(text),
  Europe: (text) =>
    UK.test(text) ||
    FR.test(text) ||
    DE.test(text) ||
    /\beurope\b|\bitaly\b|\bspain\b|\bnetherlands\b|\bsweden\b|\bnorway\b|\bswitzerland\b/.test(text),
};

export function countryRank(hospital = {}) {
  const text = [hospital.country, hospital.region, hospital.state, hospital.city]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  if (US.test(text) || text === 'us') return 0;
  if (CA.test(text)) return 1;
  if (UK.test(text)) return 2;
  if (FR.test(text) || DE.test(text)) return 3;
  if (JP.test(text) || SG.test(text)) return 4;
  if (CN.test(text)) return 5;
  if (IN.test(text)) return 6;
  return 7;
}

export function sortHospitalsByRegion(list = []) {
  return [...list].sort((a, b) => {
    const delta = countryRank(a) - countryRank(b);
    if (delta !== 0) return delta;
    return String(a.name || '').localeCompare(String(b.name || ''));
  });
}

export function matchesRegion(hospital, region) {
  if (!region || region === 'All') return true;
  const text = [hospital.region, hospital.country].filter(Boolean).join(' ').toLowerCase();
  const matcher = REGION_MATCHERS[region];
  if (matcher) return matcher(text);
  return text.includes(String(region).toLowerCase());
}

export const CARE_FEATURES = [
  { to: '/find-hospitals', label: 'Hospitals' },
  { to: '/find-oncologists', label: 'Oncologists' },
  { to: '/second-opinion', label: 'Second opinion' },
  { to: '/treatment-options', label: 'Treatment' },
  { to: '/cost-calculator', label: 'Costs' },
  { to: '/journey-builder', label: 'Packages' },
  { to: '/teleconsultation', label: 'Video consult' },
];

export const ONCOLOGIST_REGIONS = [
  { value: 'USA', label: 'United States' },
  { value: 'Canada', label: 'Canada' },
  { value: 'UK', label: 'United Kingdom' },
  { value: 'France', label: 'France' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'China', label: 'China' },
  { value: 'India', label: 'India' },
  { value: 'Europe', label: 'Europe' },
  { value: 'All', label: 'All regions' },
];

export function centresSummary(count, region, cancer) {
  const place = ONCOLOGIST_REGIONS.find((row) => row.value === region)?.label;
  const noun = count === 1 ? 'centre' : 'centres';
  const where = place && region !== 'All'
    ? (place.startsWith('United') ? ` in the ${place}` : ` in ${place}`)
    : '';
  const kind = cancer ? ` for ${cancer}` : '';
  return `${count} ${noun}${where}${kind}`;
}
